import React, { useEffect, useState } from "react";
import Average from "../../../assets/icons/average-profit.svg";
import Trade from "../../../assets/icons/no-of-trade.svg";
import Results from "../../../assets/icons/results.svg";
import RRR from "../../../assets/icons/rrr.svg";
import Win from "../../../assets/icons/win.svg";
import "./LongShortBal.scss";
import CurveGraph from "../../../reusableComponents/CurveGraph/CurveGraph";
import { FormatUSD } from "../../../utils/helpers/string";

const LongShortBal = ({ long_short_comp }) => {
  const [longShortComp, setLongShortComp] = useState(
    long_short_comp?.long_short_comp || null
  );

  console.log("long_short_comp", long_short_comp);
  const [longSelectedGraph, setLongSelectedGraph] = useState("balance");
  const [shortSelectedGraph, setShortSelectedGraph] = useState("balance");

  useEffect(() => {
    if (long_short_comp === null || long_short_comp === undefined) {
      setLongShortComp(null);
    } else if (long_short_comp?.long_short_comp) {
      setLongShortComp(long_short_comp.long_short_comp);
    }
  }, [long_short_comp]);

  // Long chart data
  const longChartData = longShortComp?.Long_chart || {};
  const longDates = longChartData.dates || [];
  const longBalance = longChartData.balance?.flat() || [];
  const longNumberOfTrades = longChartData.number_of_trades || [];

  // Short chart data
  const shortChartData = longShortComp?.short_chart || {};
  const shortDates = shortChartData.dates || [];
  const shortBalance = shortChartData.balance?.flat() || [];
  const shortNumberOfTrades = shortChartData.number_of_trades || [];

  // Dynamic series data for long chart
  const longChartSeries = [
    {
      name: longSelectedGraph === "balance" ? "Balance" : "No. of Trades",
      data: longSelectedGraph === "balance" ? longBalance : longNumberOfTrades,
    },
  ];

  // Dynamic series data for short chart
  const shortChartSeries = [
    {
      name: shortSelectedGraph === "balance" ? "Balance" : "No. of Trades",
      data:
        shortSelectedGraph === "balance" ? shortBalance : shortNumberOfTrades,
    },
  ];

  // Categories for the charts (x-axis)
  const longChartCategories =
    longSelectedGraph === "balance" ? longDates : longDates;
  const shortChartCategories =
    shortSelectedGraph === "balance" ? shortDates : shortDates;

  // Helper to render comparison boxes
  const renderComparisonBox = (
    title,
    icon,
    longValue,
    shortValue,
    format = (val) => val
  ) => (
    <div className="comparison-box">
      <div className="part-one">
        <p className="pera">{title}</p>
        <div className="image">
          <img src={icon} alt={title} />
        </div>
      </div>
      <div className="part-two">
        <div className="long">
          <p className="long-green">Long</p>
          <p>{longValue !== undefined ? format(longValue) : "N/A"}</p>
        </div>
        <div className="short">
          <p className="short-red">Short</p>
          <p>{shortValue !== undefined ? format(shortValue) : "N/A"}</p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="longShortBalMain">
      <div className="account-analysis">
        <div className="comparison">
          <p className="comparison-title">Long/Short Comparison</p>
          <div className="long-short-comparison">
            {renderComparisonBox(
              "No. of Trades",
              Trade,
              longShortComp?.number_of_long_trade,
              longShortComp?.number_of_Short_trade
            )}
            {renderComparisonBox(
              "Results",
              Results,
              longShortComp?.long_profit,
              longShortComp?.short_profit,
              FormatUSD
            )}
            {renderComparisonBox(
              "Win Rate",
              Win,
              longShortComp?.long_win_rate,
              longShortComp?.short_win_rate,
              (val) => `${val.toFixed(2)}%`
            )}
            {renderComparisonBox(
              "Average Profit",
              Average,
              longShortComp?.long_avg_profit,
              longShortComp?.short_avg_profit,
              FormatUSD
            )}
            {renderComparisonBox(
              "RRR",
              RRR,
              longShortComp?.long_rrr,
              longShortComp?.short_rrr,
              (val) => `${val.toFixed(2)}`
            )}
          </div>
        </div>

        <div className="graph_Wrapper_">
          <div className="graph">
            <div className="header_Box">
              <h2>
                Long{" "}
                {longSelectedGraph === "balance" ? "Balance" : "No. of Trades"}
              </h2>
              <div className="buttonWrapper">
                <button
                  className={`Btn ${
                    longSelectedGraph === "balance" ? "activeGraph" : ""
                  }`}
                  onClick={() => setLongSelectedGraph("balance")}
                  aria-pressed={longSelectedGraph === "balance"}
                >
                  Balance
                </button>
                <button
                  className={`Btn traderBtn ${
                    longSelectedGraph === "trades" ? "activeTraders" : ""
                  }`}
                  onClick={() => setLongSelectedGraph("trades")}
                  aria-pressed={longSelectedGraph === "trades"}
                >
                  No. of Trades
                </button>
              </div>
            </div>

            <CurveGraph
              series={longChartSeries}
              categories={longChartCategories}
              graphType={"Date"}
            />
          </div>
          <div className="graph">
            <div className="header_Box">
              <h2>
                Short{" "}
                {shortSelectedGraph === "balance" ? "Balance" : "No. of Trades"}
              </h2>
              <div className="buttonWrapper">
                <button
                  className={`Btn ${
                    shortSelectedGraph === "balance" ? "activeGraph" : ""
                  }`}
                  onClick={() => setShortSelectedGraph("balance")}
                  aria-pressed={shortSelectedGraph === "balance"}
                >
                  Balance
                </button>
                <button
                  className={`Btn traderBtn ${
                    shortSelectedGraph === "trades" ? "activeTraders" : ""
                  }`}
                  onClick={() => setShortSelectedGraph("trades")}
                  aria-pressed={shortSelectedGraph === "trades"}
                >
                  No. of Trades
                </button>
              </div>
            </div>

            <CurveGraph
              series={shortChartSeries}
              categories={shortChartCategories}
              graphType={"Date"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LongShortBal;
